import { validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { totemService } from '@/services/totem';
import useVuelidate from '@vuelidate/core';
import { integer, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useTotem() {
    const crudAction = useCrudActions();

    const model = reactive({
        value: null,
        frequency: 0,
        limitCount: 0,
        cooldown: 0,
        isSpecial: false
    });

    const validations = {
        value: {
            required,
            format: validateFormat(/^\d+(,\d+)*$/, 'Please enter in the correct format: Ex: 2,3,5 [in integer numbers]')
        },
        frequency: { required, integer },
        limitCount: { required, integer },
        cooldown: { required, integer },
        isSpecial: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: totemService().get,
        onSuccess: ({ data }) => {
            model.value = data.value;
            model.frequency = data.frequency;
            model.limitCount = data.limitCount;
            model.cooldown = data.cooldown;
            model.isSpecial = data.isSpecial;
        },
        onError: () => {
            model.value = null;
            model.frequency = 0;
            model.limitCount = 0;
            model.cooldown = 0;
            model.isSpecial = false;
        },
        onFinally: () => v$.value.$reset()
    });

    const update = crudAction.excuteAndNotify({
        validator: v$,
        request: () =>
            totemService().update(model.value, model.frequency, model.limitCount, model.isSpecial, model.cooldown),
        onSuccess: fetch
    });

    return { model, v$, fetch, update };
}
